<script setup lang="ts">
import { useCategoriesStore } from '@/entities/categories/index';
import { CategoriesList } from '@/widgets/categoriesList';

const categoriesStore = useCategoriesStore();
</script>

<template>
  <div class="categories">
    <div class="categories__header">
      <CategoriesList :categories="categoriesStore.parentCategories" :is-parent="true" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.categories {
  .flex-column(@size-x4);

  border: 1px solid @color-alto;
  border-radius: @size-x4;
  background: #fff;
  padding: @size-x5 @size-x4;

  &__icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: @size-x10;
    height: @size-x10;
    overflow: hidden;
    background: #fff;
    border-radius: @size-x2;
  }

  &__icon {
    display: block;
    object-fit: cover;
    width: @size-x10;
    height: @size-x10;
  }

  &__header {
    .flex-column(@size-x3);
  }

  @media @1024 {
    padding: @size-x4 @size-x3;
  }
}
</style>
